import { useId } from 'react';
import type { SVGAttributes } from 'react';
import { cx } from './cx';
import s from './Mark.module.css';

/**
 * Props are closed rather than the usual spread of SVG attributes. This is the one
 * component in the product allowed to draw in seal, and an attribute spread would let a
 * call site pass `fill` or `stroke` — an inline paint over the seal tile that
 * check-brand.sh cannot see, because it greps CSS and never reads the call site.
 */
export interface MarkProps {
  size?: number;
  /** Set only where the mark stands alone. Beside a wordmark that already says "rypt" it
   *  is decorative, and announcing it twice is noise. */
  title?: string;
}

export function Mark({ size = 24, title }: MarkProps) {
  const id = useId();
  const labelling: SVGAttributes<SVGSVGElement> =
    title === undefined
      ? { 'aria-hidden': true, focusable: 'false' }
      : { role: 'img', 'aria-labelledby': id };

  return (
    <svg {...labelling} width={size} height={size} viewBox="0 0 64 64">
      {title === undefined ? null : <title id={id}>{title}</title>}
      <rect className={s.tile} width="64" height="64" rx="4" />
      <rect className={s.glyph} x="19.75" y="12.75" width="8.5" height="37.5" />
      <path className={cx(s.glyph, s.shoulder)} d="M24 28 C24 20.5 30.5 17 39.5 17" />
    </svg>
  );
}

export default Mark;
